module.exports = __webpack_public_path__ + "static/media/check-circle.4cbd0385.svg";